import log from "loglevel";
import {
  BoundBox,
  getPlanarDistanceSquared,
  normalizeLatLng,
  heightAtLatLng,
} from "../utils/mapping-functions";

// const isLive = true;
// const srcURL = isLive
//   ? "http://www.gmrt.org/services/GridServer"
//   : "http://localhost:8010/proxy";
// proxy works using this https://github.com/garmeeh/local-cors-proxy
// install that locally and then run this:
// lcp --proxyUrl http://www.gmrt.org/services/GridServer

const byteArrayToLong = function (/*byte[]*/ byteArray) {
  return new Promise(async function (resolve) {
    var value = 0;
    for (var i = byteArray.length - 1; i >= 0; i--) {
      value = value * 256 + byteArray[i];
    }
    resolve(
      value
        .toString()
        .split(",")
        .map((x) => +x)
    );
  });
};

class HeightMap {
  constructor(heightMapLiteral) {
    this.boundBox = new BoundBox(heightMapLiteral.boundBox);
    this.altitudes = [];
    this.roads = [];
    this.buildings = [];
    if (heightMapLiteral.buildings) {
      for (let i = 0; i < heightMapLiteral.buildings.length; i++) {
        this.buildings.push({
          positionsArray: heightMapLiteral.buildings[i].positionsArray,
          type: heightMapLiteral.buildings[i].type,
          name: heightMapLiteral.buildings[i].name,
        });
      }
    }
    if (heightMapLiteral.roads) {
      for (let i = 0; i < heightMapLiteral.roads.length; i++) {
        this.roads.push({
          positionsArray: heightMapLiteral.roads[i].positionsArray,
          type: heightMapLiteral.roads[i].type,
          name: heightMapLiteral.roads[i].name,
        });
      }
    }
    // Check if the Altitude Values are Actual numbers or NaN
    for (let i = 0; i < heightMapLiteral.altitudes.length; i++) {
      this.altitudes[i] = [];
      for (let j = 0; j < heightMapLiteral.altitudes[0].length; j++) {
        if (Number.isInteger(heightMapLiteral.altitudes[i][j])) {
          this.altitudes[i].push(heightMapLiteral.altitudes[i][j]);
        }
      }
    }

    this.noOfVertices = {
      x: this.altitudes.length,
      y: this.altitudes[0].length,
    };

    let threeVerticesAlts = [];
    for (let j = 0; j < this.altitudes.length; j++) {
      for (let i = 0; i < this.altitudes[0].length; i++) {
        threeVerticesAlts.push(this.altitudes[j][i]);
      }
    }
    let min = 100000000;
    let max = -min;
    for (let i = 0; i < threeVerticesAlts.length; i++) {
      if (threeVerticesAlts[i] > max) {
        max = threeVerticesAlts[i];
      }
      if (threeVerticesAlts[i] < min) {
        min = threeVerticesAlts[i];
      }
    }
    this.heightLimits = {
      min: min,
      max: max,
    };
    threeVerticesAlts.sort(function (a, b) {
      return a - b;
    });

    this.heightLimits = {
      min: threeVerticesAlts[0],
      max: threeVerticesAlts[threeVerticesAlts.length - 1],
    };
  }

  heightAtLatLng(latLng) {
    const vert = normalizeLatLng(latLng, this.boundBox);
    const pos = {
      x: vert.x * (this.noOfVertices.x + 1) - 1,
      y: vert.y * (this.noOfVertices.y + 1) - 1,
    };
    const h00 = this.altitudes[Math.floor(pos.x)][Math.floor(pos.y)];
    const h01 = this.altitudes[Math.floor(pos.x)][Math.floor(pos.y + 1)];
    const h10 = this.altitudes[Math.floor(pos.x + 1)][Math.floor(pos.y)];
    const h11 = this.altitudes[Math.floor(pos.x + 1)][Math.floor(pos.y + 1)];
    const indexX = Math.abs(pos.x) - Math.floor(pos.x);
    const indexY = Math.abs(pos.y) - Math.floor(pos.y);
    return {
      ...vert,
      z:
        h00 * (1 - indexX) * (1 - indexY) +
        h10 * indexX * (1 - indexY) +
        h01 * (1 - indexX) * indexY +
        h11 * (indexX * indexY),
    };
  }

  static createFromGTiff = (gTiffimage, gTiffData, highways, building) => {
    let h = highways;
    let b = building;
    return new Promise(async function (resolve) {
      byteArrayToLong(gTiffData).then((value2) => {
        let ar = value2;
        const gTiffWidth = gTiffimage.getWidth();
        const gTiffbbox = gTiffimage.getBoundingBox();
        const gTiffBoundBox = {
          north: gTiffbbox[3],
          east: gTiffbbox[2],
          south: gTiffbbox[1],
          west: gTiffbbox[0],
        };

        const hArray = [];

        for (let i = 0; i < gTiffWidth; i++) {
          hArray[i] = [];
          for (let j = 0; j < ar.length / gTiffWidth; j++) {
            hArray[i][j] = parseInt(ar[i + j * gTiffWidth]);
          }
        }
        resolve(
          new HeightMap({
            boundBox: gTiffBoundBox,
            altitudes: hArray,
            roads: h,
            buildings: b,
          })
        );
      });
    });
  };

  static createFromBoundBox = (boundBox) => {
    log.info(boundBox);
    if (boundBox.size.x < 270 || boundBox.size.y < 270) {
      boundBox = boundBox.increaseBounds;
    }
    log.info(boundBox);
    return new Promise(async function (resolve) {
      const urlVectorMaps =
        "https://overpass-api.de/api/interpreter?data=" +
        "[out:json][timeout:25];" +
        "(way" +
        '["' +
        "highway" +
        '"]' +
        "(" +
        boundBox.south +
        "," +
        boundBox.west +
        "," +
        boundBox.north +
        "," +
        boundBox.east +
        ");" +
        "way" +
        '["' +
        "building" +
        '"]' +
        "(" +
        boundBox.south +
        "," +
        boundBox.west +
        "," +
        boundBox.north +
        "," +
        boundBox.east +
        "););" +
        "out body;%3E;out skel qt;";
      const urlHeightMap =
        // "https://cors-anywhere.herokuapp.com/" +
        "https://www.gmrt.org/services/GridServer?west=" +
        boundBox.west +
        "&east=" +
        boundBox.east +
        "&south=" +
        boundBox.south +
        "&north=" +
        boundBox.north +
        "&resolution=max&format=geotiff&layer=topo";

      const responseVector = await fetch(urlVectorMaps);
      const r = await responseVector.json();
      const fullFile = osmtogeojson(r);
      let file = fullFile.features;
      let highways = [];
      let buildings = [];
      for (let i = 0; i < file.length; i++) {
        let tags = file[i].properties.tags;
        let posArray = [];
        if ("highway" in tags) {
          if (file[i].geometry.type == "LineString") {
            for (let j = 0; j < file[i].geometry.coordinates.length; j++) {
              let x = file[i].geometry.coordinates[j][0];
              let y = file[i].geometry.coordinates[j][1];
              let p = {
                lat: y,
                lng: x,
              };
              if (boundBox.isPointWithin(p)) {
                posArray.push(p);
              } else {
                break;
              }
            }
          }
          let highwayType = file[i].properties.tags.highway;
          let highwayName = file[i].properties.tags.name;
          highways.push({
            positionsArray: posArray,
            type: highwayType,
            name: highwayName,
          });
        } else if ("building" in tags) {
          for (let j = 0; j < file[i].geometry.coordinates[0].length; j++) {
            let x = file[i].geometry.coordinates[0][j][0];
            let y = file[i].geometry.coordinates[0][j][1];
            let p = {
              lat: y,
              lng: x,
            };
            if (boundBox.isPointWithin(p)) {
              posArray.push(p);
            } else {
              break;
            }
            let buildingType = file[i].properties.tags.building;
            let buildingName = file[i].properties.tags.name;
            buildings.push({
              positionsArray: posArray,
              type: buildingType,
              name: buildingName,
            });
          }
        }
      }

      const responseHeights = await fetch(urlHeightMap);
      const blb = await responseHeights.blob();
      const gTiff = await GeoTIFF.fromBlob(blb);
      const gTiffImage = await gTiff.getImage(0);
      const gTiffData = await gTiffImage.readRasters();
      HeightMap.createFromGTiff(
        gTiffImage,
        gTiffData,
        highways,
        buildings
      ).then((value) => {
        resolve(value);
      });
    });
  };
}

export { HeightMap };
